import PropTypes from 'prop-types';
import { Box, Typography, Button } from '@mui/material';

const SupportingDataRow = ({ label, primaryText, secondaryText, salesforceUrl, onViewInCrm }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 24px',
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: '10px',
            fontWeight: 600,
            textTransform: 'uppercase',
            color: 'text.tertiary',
            letterSpacing: '0.5px',
            mb: '4px',
          }}
        >
          {label}
        </Typography>
        <Typography
          sx={{
            fontSize: '13px',
            fontWeight: 600,
            color: 'text.primary',
          }}
        >
          {primaryText}
        </Typography>
        {secondaryText && (
          <Typography
            sx={{
              fontSize: '12px',
              color: 'text.secondary',
            }}
          >
            {secondaryText}
          </Typography>
        )}
      </Box>

      {salesforceUrl && (
        <Button
          component='a'
          href={salesforceUrl}
          target='_blank'
          rel='noopener noreferrer'
          variant='outlined'
          size='small'
          onClick={onViewInCrm}
          sx={{
            fontSize: '11px',
            fontWeight: 500,
            textTransform: 'none',
            whiteSpace: 'nowrap',
            ml: 2,
          }}
        >
          View in CRM
        </Button>
      )}
    </Box>
  );
};

SupportingDataRow.propTypes = {
  label: PropTypes.string.isRequired,
  primaryText: PropTypes.string.isRequired,
  secondaryText: PropTypes.string,
  salesforceUrl: PropTypes.string,
  onViewInCrm: PropTypes.func,
};

export default SupportingDataRow;
